<template>
  <div class="sidebar-wrap" v-bind:class="{opened: opened}">
    <div class="menu">
      <div class="header">
        <i class="icon toggle-icon" @click="toggle"></i>
      </div>
      <div class="links">
        <div v-show="">
          <i v-bind:class="'icon charts-icon ' + (opened ? 'active' : '')"></i>
        </div>
      </div>
    </div>
    <div class="content-wrap" v-if="opened">
      <div class="header">
        <div class="title">Charts {{chartsAdGroupTitle}}</div>
      </div>
      <div class="content" v-if="!chartsAdGroupTitle">
        Pleaese, select adgroup
      </div>
      <div class="content" v-if="chartsAdGroupTitle">
        <div class="body">
          <div class="metrics-wrapper">
              <div 
                class="metric" 
                v-for="title, key in chartsItems" 
                v-bind:class="[{active: selectedChartsItems.indexOf(key) !== -1, }, 'metric-' + key]"
                @click="toggleSelectedChartItem(key)"
              >
                  <div class="title">{{title}}</div>
                  <div class="value">
                    <template v-if="chartsDataStatus === 'loading'">
                      <Spinner color="#797979" size="12px"></Spinner>
                    </template>
                    <template v-else>
                      {{getFormatedMetricValue(key)}}
                    </template>
                  </div>
              </div>
          </div>
          <div class="charts">
            <div 
              v-bind:class="['chart chart-' + (charts.length > 1 ? 2 : 1)]" v-for="chart in charts">
                <highcharts :options="chart"></highcharts>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import VueHighcharts from 'vue-highcharts';
  import Vue from 'vue';
  import moment from 'moment';
  import QueryBuilder from '@/graphql/QueryBuilder';
  import GQ from '@/graphql/GQ';
  import { LineScalePulseOutRapidLoader as Spinner } from 'vue-loaders';

  Vue.use(VueHighcharts);

  export default {
    name: "adgroup-report-right-side-bar",
    props: { 
      opened: {
        type: Boolean,
        required: true
      },

      dailyReportFilters: {
        type: Object,
        required: false,
        default: () => { return {};}
      }
    },
    components: {
      VueHighcharts,
      Spinner
    },
    data() {
      return {
          chartsData : {},
          chartsDataStatus: null,
          chartsItems : {
            'boughtClicks': 'Bought',
            'cost' : 'Cost',
            'cpc' : 'CPC',
            'soldClicks' : 'Sold', 
            'revenue' : 'Revenue',   
            'rpc' : 'RPC',
            'opCtr' : 'CTR',
            'rps' : 'RPS',
            'profit': 'Profit',
            'tq' : 'TQ'
          },

          selectedChartsItems: [
            'boughtClicks'
          ]          
      }
    },

    updated() {  
      this.paintMetric();
    },

    watch: {
      dailyReportFilters: function(dailyReportFilters) {
        this.loadDailyReport();
      }
    },

    computed: {  
      
      chartsDays: function() {
        return _.map(this.chartsData, v => moment(v.date).format('D MMM YYYY'));
      },

      charts: function() {
        
        let groups =  [
          [ ['boughtClicks','soldClicks'], ['opCtr'] ],
          [ ['cost', 'revenue', 'profit'] ],
          [ ['rpc', 'rps', 'cpc'] ],
          [ ['tq'] ]
        ];

        let charts = [];
        if( this.chartsDataStatus !== 'loading' ) {
          groups.map(group => {
            let groupChart = this.highchartsOptions(group);            
            if( groupChart ) charts.push(groupChart);
          })
        }

        return charts;
      },

      chartsAdGroupTitle: function(){
        let adgroup = _.get(this.dailyReportFilters, 'adGroupName', '');
        if( adgroup.length > 0 ) {
          return ' for Ad Group: ' + adgroup;
        }
        return '';
      } 
    },

    methods: {

      paintMetric: function() {
          _.map(this.chartsItems, (title, key) => {
            let color = this.getChartColor(key);
            if( this.selectedChartsItems.indexOf(key) === -1 ) color = null;          
            let elem = document.querySelector('.metric.metric-' + key);  
            if( elem ) elem.style.borderColor = color;
          })
      },

      getChartColor: function(key) {
        let index = 0;
        _.some(this.chartsItems, (title, iKey) => {
            index++;
            return iKey === key;
        })
        return this.Highcharts.getOptions().colors[index];
      },

      highchartsOptions: function (groups) {

        let series = [];
        let yAxis  = [];
        _.map(groups, (metrics, yAx)  => {

          yAxis.push({
            title: false,
            opposite: yAx !== 0,
            labels: {
              format: '{value}',                            
            }                
          })

          _.map(metrics, metric => {
            if( this.selectedChartsItems.indexOf(metric) === -1 ) return;
            series.push({
              name : this.chartsItems[metric],
              data: _.map(this.chartsData, v => v[metric] ? v[metric] : 0),
              yAxis: yAx,
              color: this.getChartColor(metric)
            });
          })
        });

        if( series.length === 0 ) {
          return false;
        }

        return {
          chart: {
            type: 'spline',
            zoomType: 'xy',
            //width: '500'
          },
          title: {
            text: this.chartsDays.length + ' days range view',
            x: -20 //center
          },
          xAxis: {
            categories: this.chartsDays
          },
          yAxis: yAxis,
          tooltip: {
            pointFormat: "{series.name}: {point.y:,.2f}"
          },
          legend: {
            layout: 'vertical',
            align: 'right',
            verticalAlign: 'middle',
            borderWidth: 0
          },
          series: series,
          responsive: {
            rules: [{
              condition: {
                maxWidth: 500,
                minWidth: 300
              },
              chartOptions: {
                chart: {
                  height: 300
                },
                subtitle: {
                  text: null
                },
                navigator: {
                  enabled: false
                }
              }
            }]
          }
        };
        
      },


      toggleSelectedChartItem(key) {
        let index = this.selectedChartsItems.indexOf(key);
        if( index === -1 ) {
          this.selectedChartsItems.push(key);
        } else {
          this.selectedChartsItems.splice(index, 1);
        }

        this.paintMetric();
      },

      getFormatedMetricValue(key) {
        let value = 0;
        switch(key) {
          case 'opCtr':
            var bought = this.getMetricValue('boughtClicks');
            if( bought != 0 ) {
              var sold = this.getMetricValue('soldClicks');
              value = sold/bought * 100;
            }
            break;

          case 'cpc':
            var bought = this.getMetricValue('boughtClicks');
            if( bought != 0 ) {
              var cost = this.getMetricValue('cost');
              value = cost/bought;
            }
            break;
          
          case 'rps':
            var bought = this.getMetricValue('boughtClicks');
            if( bought != 0 ) {
              var revenue = this.getMetricValue('revenue');
              value = revenue/bought;
            }
            break;

          case 'rpc':
            var sold = this.getMetricValue('soldClicks');
            if( sold != 0 ) {
              var revenue = this.getMetricValue('revenue');
              value = revenue/sold;
            }
            break;

          case 'tq':
             _.filter(this.chartsData, v => { if( _.isNumber(v[key]) ) value = v[key]; });
            break;

          default:
            value = this.getMetricValue(key);
            break;
        }
        
        if( value === undefined ) {
          value = 'N/A';
        } else {
          value = this.roundValue(value);
          value = this.formatNumbers(value);
        }

        return value;
      },

      getMetricValue(key) {
          let filtered = _.filter(this.chartsData, v => _.isNumber(v[key]) );
          if( filtered.length == 0 ) return undefined;

          let value = _.reduce(filtered, ( value, data ) => {
            data = parseFloat(data[key]);
            return value + data;
          }, 0); 

          return value;
      },

      formatNumbers: function (value) {

        if (value != undefined && !isNaN(value)) {
          return value.toLocaleString('en-US', {maximumFractionDigits: 2});
        }

        return value;
      },

      roundValue: function (value) {
        let precision = 2;
        if (value !== undefined && !isNaN(value)) {
          let factor = Math.pow(10, precision);
          return Math.round(value * factor) / factor;
        }

        return value;
      },

      loadDailyReport() {          

          let appliedFilters = _.cloneDeep(this.dailyReportFilters);

          let dateRange = appliedFilters.dateRangesIn[0];
          let days = moment(dateRange[1]).diff(moment(dateRange[0])) + 1;
          if( days  < 7 ) {
            dateRange[0] = moment(dateRange[1]).clone().add(-6, 'day').format('YYYY-MM-DD');
          }

          appliedFilters.dateRangesIn = [dateRange];

          let args = {
              filters: appliedFilters,
              orderBy: {'date': 'asc'}
          };

          let requestedColumns = [            
              'boughtClicks',
              'soldClicks',
              'cost',
              'cpc',
              'profit',
              'rpc',
              'opCtr',
              'revenue',
              'tq',
              'rps',
              'date'
          ];

          let qb    = new QueryBuilder();
          let query = qb.connection('adgroupReportTwo')
              .fields(requestedColumns.join(','))
              .args(args) 
              .edgesQuery();

          let self = this;

          this.chartsData = [];
          this.chartsDataStatus = 'loading';

          return GQ.query({dailyReport: query})
              .then(function(result) {
                let edges = _.get(result.dailyReport, 'edges', []);                
                edges.map( edge => {
                    let node = _.get(edge, 'node.0');
                    self.chartsData.push(node);
                })
              })  
              .catch( error => console.log(error) )            
              .finally(() => {
                self.chartsDataStatus = 'loaded';
              })
      },

      close() {
        this.$emit('close');
      },
      open() {
        this.$emit('open');
      },
      toggle() {
        if( this.opened ) {
          this.close();
        } else {
          this.open();
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .sidebar-wrap {
    background-color: #7d7d7d;
    display:grid;
    grid-template-columns: 63px auto;

    &.opened{
      position:absolute;
      z-index: 5;
      right: 0;
      width: 80vw;
      margin-right: 25px;
      border-bottom: 1px solid #979797;
      box-shadow: 1px 3px 7px 1px #cbcccd;

      .header {
        background-color: #525252;
        font-size: 20px;
        text-align: left;
        font-weight: bold;
        color: #fff;    

        .title{
          padding-top:20px;
          padding-left:20px;
        }  
      }
    }

    .icon {
      display: inline-block;
      width: 64px;
      height: 64px;
      cursor: pointer;

      &.active {
        background-color: #ffffff;
      }
    }
  }

  .content-wrap {
    background-color: #f0f0f0;  
  }

  .header {
    height: 64px;    
  }

  .content {
    padding: 20px;
    height: calc( 100% - 64px );    
  }

  .body {
    background: #fff;
    height: 100%;
    width: 100%;
    border: 2px solid #d7d7d7;
    overflow: scroll;
  }

  .toggle-icon {
    background: url('/static/img/right-sidebar-toggle-icon.svg') center no-repeat;
  }

  .charts-icon {
    background: url('/static/img/right-sidebar-charts-icon.svg') center no-repeat;
    &.active {
      background: url('/static/img/icon-charts-showed.svg') center no-repeat;
    }
  }

  .charts {
    display:block;

    .chart-1 {
      width: 100%;
    }

    .chart-2 {
      width: 50%;
      display: block;
      float: left;
    }
  }

  .edit-icon {
    background: url('/static/img/right-sidebar-edit-icon.svg') center no-repeat;
  }


  .metrics-wrapper {
    display: grid;
    grid-template-columns: repeat(auto-fill,minmax(130px, 1fr));
    padding: 15px;
    grid-gap: 10px;

    .metric {
      width: 130px;
      padding: 15px;
      border: 1px solid #d7d7d7;
      border-radius: 5px;
      margin-right: 15px;
      text-align: left;
      cursor: pointer;
      font-size: 14px;      

      &.active {
        border: 2px solid #4a90e2;
      }

      .title {
        padding-bottom: 5px;
        color: #797979;
      }

      .value {
        font-weight: bold;
        font-size:20px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/reports/adgroupReport2/RightSideBar.vue